import { authCheck, plain, secured } from '@/app/config/axios';

const resource = 'auth';

export default {
    user: () =>
        authCheck.get(`${resource}/user`, {
            headers: {
                'Cache-Control': 'no-cache',
            },
        }),
    updateUser: (data: any) => secured.put(`${resource}/user`, data),
    logout: () => secured.post(`${resource}/logout`),
    keycloakLogin: (userId: string | undefined, userToken: string | undefined, userRefreshToken: string | undefined) =>
        plain.post(`${resource}/keycloak-login`, {
            profile: userId,
            accessToken: userToken,
            refreshToken: userRefreshToken,
        }),
};
